import { GxIcon } from '@garpix/garpix-web-components-react'
import { place1Icon, place2Icon, place3Icon } from '@/images'
import classNames from 'classnames'
import React from 'react'
import style from './styles/tag.module.scss'

const PlaceTag = ({ place = '', size = 'medium' }): React.ReactElement => {
  let icon

  switch (place) {
    case '1': {
      icon = place1Icon
      break
    }
    case '2': {
      icon = place2Icon
      break
    }
    case '3': {
      icon = place3Icon
      break
    }
    default: {
      icon = ''
      break
    }
  }

  return (
    <span
      className={classNames({
        [style.tag]: true,
        [style.theme_blue]: true,
        [style[`size_${size}`]]: true
      })}
    >
      {icon !== ''
        ? (
          <GxIcon src={icon} className={style.tag__icon} />
          )
        : undefined}
      {`${place} место`}
    </span>
  )
}

export default PlaceTag
